<template>
    <div id="app">
        <!-- <button @click="scan">扫一扫</button> -->
        <div>result: {{ result }}</div>
        <pre v-if="debug" style="text-align: left">{{ res }}</pre>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import {Dialog} from 'vant';
function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
export default {
    name: 'App',
    components: {},
    data() {
        return {
            res: {},
            debug: true,
            result: '',
            config: {}
        };
    },
    created() {
        Dialog.alert({
            message: '请扫描电池二维码'
        }).then(() => {
            this.scan();
        });
        this.$request({
            url: 'aseos/battery/wxsign',
            data: {
                url: document.location.href.split('#')[0]
            }
        }).then((res) => {
            this.res = res;
            let {appId, timestamp, nonceStr, signature} = res;
            wx.config({
                debug: this.debug,
                appId,
                timestamp,
                nonceStr,
                signature,
                jsApiList: ['checkJsApi', 'scanQRCode']
            });
        });
        // this.sendInfo('sdfsdfsdf');
        wx.error(function (res) {
            alert('出错了：' + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
        });

        wx.ready(() => {
            Dialog.alert({
                message: '请扫描电池二维码'
            }).then(() => {
                this.scan();
            });
        });
    },
    methods: {
        scan() {
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
                success: (res) => {
                    // self.$toast('weixin scanQRCode success', 'success');
                    this.result = res.resultStr;
                    this.sendInfo(this.result);
                }
            });
        },
        sendInfo(str) {
            this.$request({
                url: 'aseos/battery/batteryInfo',
                data: {
                    sn: getUrlParam('sn'),
                    str: str
                }
            });
        }
    }
};
</script>

<style>
html body {
    height: 100vh;
}
</style>
